const en = {
    btn: {
        logout: 'Sign Out',
        Cancel: 'Cancel',
        Reset: 'Reset',
        Confirm: 'Confirm',
        addOrg: 'Add New Member',
        operation: 'Operate',
        viewmember: 'View Members',
        viewpermission: 'View Permissions',
        create: 'Add New',
        querySame: 'Deduplicate',
        import: 'Import',
        importing: 'Importing...',
        importings: 'Importing',
        export: 'Export',
        exporting: 'Exporting...',
        exportings: 'Exporting',
        detail: 'Check for Details',
        edit: 'Edit',
        delete: 'Delete',
        receive: 'Receive',
        receiving: 'Claiming...',
        deactivate: 'Deactivate',
        switchOpen: 'Enable',
        switchOpening: 'Activating...',
        deactivating: 'Deactivating...',
        transfer: 'Transfer',
        transferIng: 'Transfering...',
        distribute: 'Disribute',
        distributing: 'Assigning...',
        transferClient: 'Tranfer Client',
        associatedContacts: 'Associated Contacts',
        disassociate: 'Disassociate',
        uploadAttachment: 'Upload Attachment',
        viewAllRecords: 'View All Records',
        viewPermission: 'View Permissions',
        upload: 'Upload',
        download: 'Download',
        downloading: 'Download...',
        deleting: 'Deleting...',
        associatedOppty: 'Associate Opportunity',
        associat: 'Associate',
        addNewRecord: 'New record',
        publishing: 'Publishing...',
        uploading: 'Attachment is being uploaded, please wait.',
        publishRecord: 'Release record',
        updating: 'Updating...',
        update: 'Update',
        addNewContact: 'New Contacts',
        addNewClient: 'Create new Client',
        save: 'Save',
        search: 'Search',
        exportSelected: 'Export selected data',
        submit: 'Submit',
        importOppty: 'Opportunity import',
        importContact: 'Contact import',
        importLead: 'Lead import ',
        putInLeadPool: 'Place in Lead Pool',
        transferClienting: 'Converting to client...',
        pullInOpenSea: 'Place in Open Sea',
        pullIning: 'Placing...',
        importClient: 'Client import',
        transferLead: 'Lead transfer',
        transferClients: 'Lead transfer',
        editDetails: 'Edit details',
        changeStatus: 'Change Status',
        addAttachment: 'Add Attachment',
        publicAttachment: 'Rekease Attachment',
        createLeadTodo: 'Create lead to-do'
    },
    menu: {
        title: 'GBU CRM',
        dashboard: 'DashBoard',
        lead: 'Lead',
        leadManagement: 'Lead',
        leadPool: 'Lead Pool',
        accounts: 'Client',
        accountsManagement: 'Client',
        publicData: 'Open Sea',
        contactManagement: 'Contact',
        contactList: 'Contact',
        contactCreate: 'Contact Create',
        contactDetail: 'Contact Detail',
        businessManagement: 'Opportunity',
        business: 'Opportunity',
        label: 'Label',
        analysis: 'Data Analysis',
        leadAnalysis: 'Lead Analysis',
        accountAnalysis: 'Client Analysis',
        businessAnalysis: 'Opportunity Analysis',
        setting: 'System Settings',
        staffManagement: 'Organization and Member',
        permission: 'Role and Permission',
        roleManagement: 'Role Management',
        userInfo: 'Personal Center'
    },
    users: {
        avatar: 'Profile Picture',
        name: 'Name',
        userName: 'User Name ',
        baiduEmail: 'Baidu Email ',
        belongDepartment: 'Department',
        departmentManagers: 'Department Managers',
        role: 'Role'
    },
    selectOptions: {
        notPaidBack: 'Not paid back',
        refunded: 'Refunded',
        expired: 'Expired',
        myselfSubordinates: 'Myself and My Subordinates',
        myselft: 'Myself ',
        subordinates: 'Subordinates',
        followUpStatus: 'Follow Up Status',
        notAllocated: 'Not Allocated',
        pending: 'Pending',
        invalidLead: 'Invalid Lead',
        noReplay: 'No Reply',
        followingUp: 'Following up',
        noIntention: 'No Intention',
        converted: 'Converted',
        terminated: 'Terminated',
        dealStatus: 'Deal Status',
        closedDeal: 'Closed Deal ',
        blackList: 'Cloaker',
        meetingScheduled: 'Meeting Schedule',
        postCall: 'Post Call',
        revisit: 'Revisit',
        notClosed: 'Not Closed ',
        marketEventName: 'Marketing Event Name',
        marketEvent: 'Marketing Event',
        selfExpansion: 'Self-Expansion',
        supervisorAllocation: 'Supervisor Assigned',
        superKeyAccount: 'Super Key Account',
        keyAccount: 'Key Account',
        mediumAccount: 'Midsized Account',
        smallAccount: ' Small Account',
        serviceProvider: 'Service Provider',
        ceo: 'CEO',
        cmo: 'CMO',
        otherManagement: 'Other Management Person of the Company',
        businessDirector: 'Business Director',
        businessManager: ' BD Manager',
        accountDirector: 'Account Management Director',
        accountManager: 'Account Manager',
        brandDirector: 'Brand Director',
        brandManager: 'Brand Manager',
        others: 'Others',
        clientVerification: 'Client Verification',
        needsAnalysis: 'Needs Analysis',
        proposalQuotation: 'Proposal Quotation',
        businessNegotiation: 'Business Negotiation',
        orderWon: 'Closed Won',
        orderLost: 'Closed Lost',
        salesOpportunityStage: 'Sales Opportunity Stage',
        rebatePolicyNotMeetClientExpectations: 'Rebate Policy Does Not Meet Client Expectations',
        paymentPolicyNotMeetClientExpectations: 'Payment Policy Does Not Meet Client Expectations',
        clientNotProvideMaterials: 'Client Cannot Provide Supporting Materials',
        productChanges: 'Product Changes',
        paymentIssues: 'Payment Issues',
        otherReasons: 'Other Reasons (Client Fill-In)',
        opptyStageText1:
            'Understand the Basic Information of Client Company (Such As Company Background And Size, Main Business, Target Countries and Regions, etc.)',
        opptyStageText2: "Understand Client's other advertisement spending channels and budget",
        opptyStageText3:
            'Understand the Client‘s Business Needs (Such As Products, Targeting Goals, Budget, Pain Points, etc.)',
        opptyStageText4: 'Understand Whether Clients Need Agency Services',
        opptyStageText5: 'Recommend Media Channels and Introduce Relevant Media and Case Studies',
        opptyStageText6: 'Provide Business Policies to Clients (Such As Payment Terms, Rebates, Service fees, etc.)',
        opptyStageText7: 'Confirm Media Channels and Business Policies with Clients',
        opptyStageText8: 'Provide Media Launch Solutions to Clients',
        opptyStageText9:
            'If the Clients Applies for A Non-standard Payment Terms and Rebate, Collect Supporting Materials for Internal Application',
        man: 'man',
        women: 'women',
        mediagoAgency: 'MediaGo agency',
        mediagoDsp: 'MediaGo dsp',
        facemojiKeyboard: 'Facemoji input method monetization',
        popinDiscovery: 'popIn Discovery',
        preinstalledBusiness: 'Manufacturer pre-installed business',
        selfInvestment: 'Self-investment',
        agentInvestment: 'Agent-investment'
    },
    formInfo: {
        pleaseSelectPriority: 'Please select a priority',
        pleaseSelectPaymentStatus: 'Please select the payment status',
        needZipCode: 'Please enter a valid zip code',
        mpweRequire: 'Cell Phone/Telephone/WeChat/E-mail, Please Fill In at Least One',
        pleaseEnter: 'Please Enter',
        pleaseEnterContent: 'Please Enter Content',
        pleaseEnterSearchScope: 'Please enter search range and conditions',
        pleaseSelect: 'Please Choose',
        noData: 'No Data',
        leadSelectFileText1: 'Drag the Lead File Here to Import or ',
        leadSelectFileText2: 'Select the File',
        leadUploadFileText1: 'SalesGo Lead Import Template',
        contactUploadFileText1: 'SalesGo Contact Import Template',
        opptyUploadFileText1: 'SalesGo Business Opportunity Import Template',
        clientUploadFileText1: 'SalesGo Client Import Template',
        opptyUploadFileText2: 'Download the Template and Edit Information According to the Template Format',
        opptyUploadFileText3: 'Upload Bulk Lists Here. Excel Files (.xlsx) Only',
        onlyImportXlsFile: 'Only xls/xlsx files can be uploaded!',
        maxFileTip: 'File size cannot exceed',
        duplicateFileTip: 'Duplicate data import failed, downloaded locally',
        downloadTemplate: 'Download Template',
        pleaseSelectIndustryPlaceholder: 'Client industry',
        pleaseSelectSub: 'Subcategories',
        pleaseSelectIndustry: 'Please select the Client industry first',
        pleaseSelectopptyLine: 'Please select the Business Line',
        isConfirmDeleteAttachment: 'Are you sure you want to delete the attachment?',
        isConfirmDeleteRecord: 'Are you sure you want to delete the records?',
        isConfirmDisassociate: 'Are you sure you want to disassociate?',
        isConfirmUpdateStatus: 'Are you sure you want to update the deal Status?',
        isConfirmUpdateFollowupStatus: 'Are you sure you want to update the follow-up status?',
        isConfirmStopCustomer: 'Are you sure you want to deactivate the client?',
        isConfirmStopLead: 'Are you sure you want to deactivate the lead?',
        isConfirmStopData: 'Are you sure you want to disable it?',
        isConfirmOpenData: 'Are you sure you want to enable it?',
        isConfirmOpenLead: 'Are you sure you want to enable leads?',
        isConfirmOpenCloseLead: 'Are you sure you want to deactivate/activate the leads?',
        isConfirmUpdatePrimaryContact: 'Are you sure you want to update your primary contact?',
        isCOnfirmReceiveData: 'Confirm receiving?',
        uploadNotAllowed: 'Sorry, uploading this file type is not supported at the moment',
        pleaseSelectLeadStop: 'Please select the lead to deactivate or activate',
        searchSomeText: 'Search related content',
        pleaseSelectSearchType: 'Type of search',
        pleaseEnterOrderLostReason: 'Please enter a specific reason description',
        needPhoneNumber: 'Phone number should be 6-15 digits',
        phoneIsNumber: 'Phone number should be numeric',
        emailType: 'Please enter a valid email format',
        querySameNoData: 'No data, please search for duplicates first~',
        pleaseSelectAccounts: 'Please select the Client to claim',
        pleaseSelectOpptyStage: 'Opportunity stage',
        pleaseSelectBusinessline: 'Business line',
        pleaseSelectCooperationChannels: 'Cooperation channels',
        pleaseSelectCooperationType: 'Cooperation method',
        pleaseSelectFollowupStatus: 'Follow-up status',
        pleaseSelectLeadSource: 'Lead source',
        pleaseSelectLeadSourceTip: 'Please select lead source',
        pleaseSelectLeadLevel: 'Lead grade',
        pleaseSelectCountry: 'Country',
        pleaseSelectBusinessTip: 'Optional when the business line is MediaGo agency',
        pleaseSelectCountryTip: 'Please select a country',
        pleaseSelectCity: 'City',
        pleaseSelectTargetLocation: 'Target location',
        followupStatusText: 'The following follow-up statuses are optional',
        systemFollowupStatusText: 'The following are system follow-up statuses and cannot be selected',
        isConfirmPullinLeadpool: 'Are you sure you want to place the lead in the lead pool?',
        isConfirmTransferCustomer: 'Confirm conversion to client?',
        pleaseSelectDealStatus: 'Deal status',
        pleaseSelectClientSource: 'Client source',
        pleaseSelectClientSourceTip: 'Please select client source',
        pleaseSelectClientLevel: 'Client grade',
        pleaseSelectClient: 'Please select client',
        isConfirmPullClientToOpensea: 'Are you sure you want to place the Clientin the Open Sea?',
        pleaseSelectClientStop: 'Please select the client to deactivate or activate',
        pleaseSelectPosition: 'Title',
        needTelephoneNumber: 'Phone number should be 6-15 digits',
        pleaseEnterdepartmentName: 'Please enter the department name',
        pleaseEnterName: 'Please enter the name',
        pleaseEnterOpptyName: 'Please enter the opportunity name',
        pleaseEnterClientName: 'Please enter the department name',
        pleaseEnterContactName: 'Please enter contact name',
        pleaseEnterLeadName: 'Please enter the lead name',
        pleaseEnterNumber: 'Please enter a valid number',
        pleaseSelectDepartment: 'Please select the superior department',
        pleaseSelectLoseReason: 'Please select the reason for loss',
        pleaseSelectLoseReasonInfo: 'Please enter the specific reason for loss',
        pleaseSelectRole: 'Please select a role',
        pleaseSelectPersonInCharge: 'Please select the person in charge',
        pleaseSelectPersonInChargePlaceholder: 'Person in Charge',
        pleaseSelectLeftSide: 'Please select a filter type from the left side first',
        isConfirmDeleteDepartment: 'Are you sure you want to delete this department?',
        isConfirmDeleteUser: 'Are you sure you want to delete this user?',
        leadTemplate: 'SalesGo CRM lead import template.xlsx',
        leadLink: '/api/conf/get_file?key=2024/06/25/d41d8cd98f00b204e9800998ecf8427e_1719306126080469788.xlsx',
        clientTemplate: 'SalesGo client import template.xlsx',
        clientLink: '/api/conf/get_file?key=2024/06/25/d41d8cd98f00b204e9800998ecf8427e_1719306170858672159.xlsx',
        contactTemplate: 'SalesGo contact import template.xlsx',
        contactLink: '/api/conf/get_file?key=2024/06/25/d41d8cd98f00b204e9800998ecf8427e_1719306217851352151.xlsx',
        opptyTemplate: 'SalesGo business opportunity import template.xlsx',
        opptyLink: '/api/conf/get_file?key=2024/03/12/d41d8cd98f00b204e9800998ecf8427e_1710254107644137552.xlsx',
        importInfo:
            'The import failed. The file has been downloaded locally. Please refer to the import failure description column in the table to modify it.',
        downloadFile: 'Import failed file.xlsx',
        deleteInfo:'Are you sure to delete?',
    },
    backEnd: {
        superAdmin: 'Super Admin',
        superAdminText1:
            'Preset Roles, Cannot Be Deleted, Support All Read And Write Access of All Current Organization Data',
        businessManager: 'Business Development Manager',
        businessManagerText1:
            'Preset Roles, Cannot Be Deleted, Access All Read And Write Access of Personal And Subordinate Data',
        businessSpecialist: 'Business Development Specialist',
        businessSpecialistText1:
            'Preset Roles, Cannot Be Deleted, Support Partial Read And Write Access to Access All Personal Data'
    },
    common: {
        priority: 'Priority',
        weeklyReport: 'Weekly report',
        generateWeekly: 'Generate weekly report',
        selectWeeklyDate: 'Select Date',
        month: 'Month',
        expiredDays: 'Expired Days',
        billExpireHistory: 'Bill Expires History',
        paymentStatus: 'Payment Status',
        selectFollowupTime: 'Select follow-up completion time',
        addFollowupTodo: 'Create follow-up to-do',
        type: 'Type',
        name: 'File Name',
        leadModuleId: 'Lead ID',
        clientModuleId: 'Client ID',
        contactModuleId: 'Contact ID',
        opptyModuleId: 'Opportunity ID',
        leadData: 'Lead Data',
        opptyData: 'Opportunities Data',
        customerData: 'Client Data',
        startDate: 'Start date',
        endDate: 'End date',
        followupDateStart: 'Follow up start time',
        followupDateEnd: 'Follow up end time',
        followupFinish:'Follow up finish time',
        Date: 'Date',
        compared: 'Compared',
        filterConditions: 'Filter conditions:',
        notfound404:
            'Sorry~ The page cannot be found, returning to the homepage in  <span class="timer" style="color: #2888ff;">{ second }</span>  seconds',
        backHomepage: 'Return to homepage',
        contactInfoma: 'Contact Information',
        unknown: 'Unknown',
        chinajoyText1: '2023 ChinaJoy event expansion',
        gameIndustry: 'Gaming industry',
        ordinal: {
            1: '1st',
            2: '2nd',
            3: '3rd',
            other: '{rank}th',
            '--': '--th'
        },
        data: 'data',
        addressss: 'Address - Province/City',
        addressAllText: 'Address - Province/City/District',
        zipcode: 'Zip Code',
        number: 'Quantity',
        amount: 'Amount',
        myRanking: 'My ranking',
        meiyuan: 'USD',
        items: 'items',
        user: 'User',
        rankList: 'Leaderboard',
        rank: 'Ranking',
        saleFunnel: 'Sales funnel',
        distributeAccount: 'Client assignment',
        distributeLead: 'Lead assignment',
        clientFollowupTip: 'Client follow-up reminder',
        dataSum: 'Data summary',
        compareLastMonth: 'Compared to last month',
        new: 'Add',
        salesBrief: 'Sales brief',
        module: 'Module',
        moduleName: 'Module name',
        phoneEmailWechat: 'Mobile number/Email/WeChat ID',
        clientDuplication: 'Client deduplication',
        addNewOppty: 'Add New Opportunities',
        conversionRate: 'Conversion Rate',
        selected: 'selected',
        records: 'Records',
        switchOpen: 'Enable',
        switchClose: 'Disabled',
        uploador: 'Uploader',
        opptyNumbers: 'Number of Opportunities',
        isPrimaryContact: 'Is primary contact?',
        primaryContact: 'Primary contact',
        primaryContactsPhone: "Primary contact's phone",
        yes: 'Yes',
        no: 'No',
        time: 'Time',
        followupRecords: 'Follow Up Records',
        details: 'Details',
        attachment: 'Attachment',
        contactExperience: 'Contact Experience',
        systemMsg: 'System Message',
        baseInfo: 'Basic Information',
        promotionalInfo: 'Promotional information',
        attachmentName: 'Attachment Name',
        attachmentSize: 'Attachment Size',
        uploadTime: 'Upload Time',
        noPermission: 'No Permission',
        leadName: 'Lead Name',
        leadSource: 'Source of Lead',
        leadLevel: 'Lead Level',
        relatedMarketEvents: 'Related Marketing Events',
        industry: 'Client Industry',
        addressAll: 'Address-Province/City/District',
        city: 'Location',
        address: 'Address',
        contactPerson: 'Contact',
        gender: 'Gender',
        position: 'Title',
        cellPhone: 'Cell Phone',
        telePhone: 'TelePhone',
        wechat: 'WeChat',
        email: 'E-mail',
        productName: 'Product Name',
        companySite: 'Company Official Website',
        subcategories: 'Subcategories',
        targetLocation: 'Target Location',
        aveDailySpend: 'Average Daily Budget of Other Channels',
        aveDailyBudget: 'Average Daily Budget',
        notes: 'Notes',
        customTag: 'Custom Tag',
        followupRecord: 'Follow Up Record',
        followupStatus: 'Follow Up Status',
        finishTime: 'Follow Up Finish Time',
        personCharge: 'Person In Charge',
        accountManager:'AM',
        lastContactTime: 'Last Contact Time',
        lastFollowuoRecord: 'Latest Follow-Up Record',
        duration: 'Duration',
        creator: 'Creator',
        creationTime: 'Creation Time',
        clientName: "Client's Name",
        clientSource: "Client's Source",
        clientLevel: 'Client Level',
        opptyName: 'Opportunity Name',
        opptyAmount: 'Opportunity Amount(USD)',
        opptyAmountUnit: 'Opportunity Amount(USD)',
        estimatedTime: 'Estimated Transaction Time',
        businessLine: 'Business Line',
        cooperationChannels: 'Cooperation Channels',
        cooperationMethod: 'Cooperation Method',
        rebate: 'Rebate',
        legalEntity: 'Legal Entity',
        productLink: 'Product URLs',
        country: 'Country'
    },
    settings: {
        orgManagement: 'Organization management',
        createDepartment: 'Create organization',
        departmentName: 'Department name',
        parentDepartment: 'Superior department',
        departmentLeader: 'Department Managers',
        postname: 'Position',
        createMember: 'Create member',
        baiduEmail: 'Baidu Email ',
        status: 'Status',
        name: 'Name',
        phone: 'Mobile Number',
        sex: 'Gender',
        role: 'Role',
        roleDesc: 'Description',
        forDepartment: 'Belonged Department ',
        created_at: 'Creation Time',
        email: 'Email',
        man: 'Man',
        women: 'Women',
        manandwomen: 'Unknown',
        admin: 'Super Admin',
        businessAdmin: 'Business Development Manager',
        businesser: 'Business Development Specialist',
        avatar: 'Profile Picture',
        userName: 'User Name ',
        creator: 'Creator',
        normalUser: 'Normal',
        disableUser: 'Disabled',
        staffManagement: 'Personnel Management',
        roleManagement: 'Role Management',
        userInfo: 'Personal Center',
        memberList: 'Member List',
        emptyText: 'No members in this group, please add members~',
        switchOpen: 'Enable',
        switchClose: 'Disabled',
        roleandmembersList: 'Role and member management',
        addDepartment: 'Add department',
        editDepartment: 'Edit department'
    },
    analysis: {
        lineChart: 'Line Chart',
        barChart: 'Bar Chart',
        pieChart: 'Pie Chart',
        funnelChart: 'Funnel Chart',
        adwancedFiltering: 'Advanced Filtering',
        customColumns: 'Custom Columns',
        greaterOrEqual: 'Greater Than Or Equal To',
        lessOrEqual: 'Less Than Or Equal To',
        enterNumbers: 'Enter Relevant Numbers',
        between: 'Between',
        notBetween: 'Not Between',
        dragDropRecorder: 'Drag and Drop to Recorder',
        selected: 'Selected',
        Reset: 'Reset',
        indicatorName: 'Indicator Name',
        selectAll: 'Select All',
        monthOnMonth: 'Month-on-Month',
        previousTime: 'Adjacent to the Previous Time Period',
        aggregateDimension: 'Aggregate Dimensions',
        searchDimension: 'Search Dimensions',
        reportData: 'Report Data',
        collapseLegend: 'Collapse Legend',
        expandLegend: 'Expend Legend',
        functionalLevel: 'Functional Level',
        organizationalLevel: 'Organizational Level',
        timeLevel: 'Time Level',
        leadLevel: 'Lead Level',
        clientLevel: 'Client Level',
        opportunityLevel: 'Opportunity Level',
        moduleLevel: 'Module hierarchy',
        byYear: 'By year',
        byQuarter: 'By quarter',
        byMonth: 'By month',
        byWeek: 'By week',
        byDay: 'By day',
        aggregateDimensionType: 'Aggregation dimension classification',
        searchDimensionType: 'Search dimensions classification',
        pleaseSelectAggregateDimension: 'Please select at least one aggregation dimension',
        systemModule: 'System modules',
        systemLevel: 'System Level',
        //报表名称
        LeadStatistics: 'Lead statistics',
        ClientStatistics: 'Client statistics',
        ClientgradeAnalysis: 'Clientgrade analysis',
        ClientindustryAnalysis: 'Clientindustry analysis',
        FollowUpRecordAnalysis: 'Follow-up record analysis',
        OpportunityStatistics: 'Opportunity statistics',
        OpportunityStageAnalysis: 'Opportunity stage analysis',
        opptyDataAnalysis: 'Opportunity statistics analysis',
        currentDate: 'Current Date ',
        compareDates: 'Compare Date ',
        present: 'Present',
        contrast: 'Contrast',
        orgLevelName: 'Level {orgLevel} Organization',
        total: 'total'
    },
    indicator: {
        // 线索分析
        addNewLead: 'New Lead',
        leadToClient: 'Leads Converted to Clients',
        leadToClientRate: 'Percentage of Leads Converted to Clients',
        leadToClientConverted: 'Sold Converted Leads to Clients',
        leadToClientConvertedRate: 'Percentage of Sold Converted Leads to Clients',
        leadToClientUnsold: 'Unsold Leads Converted to Clients',
        leadToClientUnsoldRate: 'Percentage of Unsold Leads Converted to Clients',
        contactedLead: 'Contacted Lead',
        contactedLeadRate: 'Percentage of Contacted Lead',
        noReplyLead: 'No Reply',
        noReplyLeadRate: 'Percentage of Unanswered Leads',
        invalidLead: 'Invalid Leads',
        invalidLeadRate: 'Percentage of Invalid Leads',
        unintentionalLeads: 'Unintentional Leads',
        unintentionalLeadsRate: 'Percentage of Unintentional Leads',
        noAssignedLeads: 'No Leads Assigned',
        noAssignedLeadsRate: 'Percentage of Unassigned Leads',
        pendingLeads: 'Leads Pending',
        pendingLeadsRate: 'Percentage of Pending Leads',
        // 客户分析
        closedClients: 'Clients with Closed Deals',
        closedClientsRate: 'Percentage of Clients with Closed Deals',
        noClosedClients: 'Clients Without Closed Deals',
        noClosedClientsRate: 'Percentage of Without Closed Deals',
        newClient: 'New Client',
        newClosedClient: 'New Client with Closed Deals',
        newClosedClientRate: 'Percentage of New Closed Won',
        newNotClosedClient: 'New Pending Clients',
        newNotClosedClientRate: 'Percentage of New Pending Clients',
        contactPerson: 'Contact',
        newContact: 'New Contacts',
        opptyAmount: 'Business Amount',
        newAccountFollowUpRecords: 'New Client Follow-Up Record',
        //商机分析
        addNewOppty: 'Add New Business Opportunities',
        addOpptyAmount: 'New Business Opportunities Potential Revenue',
        validClientStageOpptyNumber: 'Number of Business Opportunities in the Verification Client Stage',
        validClientStageOpptyAmount: 'Business Opportunities in the Verification Client Stage Potential Revenue',
        validClientStageOpptyNumberRate: 'Percentage of Business Opportunities in the Verification Client Stage',
        analysisStageOpptyNumber: 'Number of Business Opportunities in Demand Analysis Stage',
        analysisStageOpptyAmount: 'Business Opportunity in Demand Analysis Stage Potential Revenue',
        analysisStageOpptyNumberRate: 'Percentage of Business Opportunity in Demand Analysis Stage',
        quotationStageOpptyNumber: 'Number of Business Opportunities in the Proposal Quotation Stage',
        quotationStageOpptyAmount: 'Business Opportunity in the Proposal Quotation Stage Potential Revenue',
        quotationStageOpptyNumberRate: 'Percentage of Business Opportunity in the Proposal Quotation Stage',
        negotiationStageOpptyNumber: 'Number of Business Opportunities in the Business Negotiation Stage',
        negotiationStageOpptyAmount: 'Business Opportunities in the Business Negotiation Stage Potential Revenue',
        negotiationStageOpptyNumberRate: 'Percentage of Business Opportunities in the Business Negotiation Stage',
        wonOpptyNumber: 'Number of Business Opportunities Won',
        wonOpptyAmount: 'Winning Business Opportunity Revenue',
        wonOpptyNumberRate: 'Percentage of Business Opportunities in the Business Negotiation Stage',
        lostOpptyNumber: 'Number of Business Opportunities Lost',
        lostOpptyAmount: 'Business Opportunity Lost Revenue',
        lostOpptyNumberRate: 'Percentage of Lost Business Opportunities',
        //商机分析--销售阶段
        saleStageOpptyNumber: 'Number of Sales Stage Opportunities',
        saleStageLoseNumber: 'Sales Stage Churn',
        saleStageConversionNumber: 'Sales Stage Conversions',
        saleStageOpptyHoldNumber: 'Sales Stage Stays',
        saleStageOpptyLoseNumber: 'Sales Stage Stays Opportunity Revenue',
        saleStageOpptyHoldAmount: 'Sales Stage Churn Opportunity Revenue',
        saleStageOpptyAmount: 'Sales Stage Opportunity Amount',
        saleStageClientAmount: 'Number of Clients in Sales Stage',
        saleStageAveClientPrice: 'Average Clients Price During Sales Stage',
        saleStageAvecycle: 'Sales Stages Average Sales Cycle',
        saleStageConversionRate: 'Sales Stage Conversion Rate',
        //客户跟进记录
        followupRecords: 'Follow Up Records',
        addFollowup: 'Add Follow-Up Record',
        longerDays7: 'Lasts Longer Than 7 Days',
        longerDays14: 'Lasts Longer Than 14 Days',
        longerDays30: 'Duration Exceeds 30 Days',
        longerMonth3: 'Duration Exceeds 3 Months',
        longerMonth6: 'Duration Exceeds 6 Months',
        longerMonth12: 'Duration Exceeds 12 Months',
        noContactlongerDays7: 'No Contact For More Than 7 Days',
        noContactlongerDays14: 'No Contact For More Than 14 Days',
        noContactlongerDays30: 'No Contact For More Than 30 Days',
        noContactlongerMonth3: 'No Contact for More Than 3 Months',
        noContactlongerMonth6: 'No Contact for More Than 6 Months',
        noContactlongerMonth12: 'No Contact for More Than 12 Months'
    },
    date: {
        today: 'Today',
        yesterday: 'Yesterday',
        beforeToday: 'Before Today',
        totalDate: 'All Time', 
        tommorow: 'Tommorow',
        thisWeek: 'This Week',
        lastWeek: 'Last Week',
        nextWeek: 'Next Week',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        nextMonth: 'Next Month',
        thisQuarter: 'This Quarter',
        lastQuarter: 'Last Quarter',
        nextQuarter: 'Next Quarter',
        thisYear: 'This Year',
        lastYear: 'Last Year',
        nextYear: 'Nex Year'
    },
    msg: {
        deleteDone: 'Delete successful',
        confirmDone: 'Save successful',
        updateDone: 'Update successful',
        stopDone: 'Deactivation successful',
        enableDone: 'Eabled successful',
        receiveDone: 'Receiving successful',
        receiveError: 'Receiving failed',
        confirmError: 'Save failed, please try again later',
        uploadError: 'Attachment upload failed, please try again',
        workDone: 'Successful operation',
        workError: 'operation failed',
        waitExport: 'Exporting, please wait...',
        importDone: 'Import successful',
        importError: 'Import failed',
        exportDone: 'Export successful',
        exportError: 'Export failed',
        isConfirmRelogin: 'Login has expired, are you sure you want to log in again?',
        networkError: 'Network Error',
        noPermissionContact: 'No permission, please contact the administrator!',
        expiredRelogin: 'Your identity has expired, please log in again',
        permissionText: 'No access rights yet, please contact the administrator ~'
    },
    toolTip: {
        dataAnalysisChartTip: 'The chart currently does not support viewing dimensions: Subcategories, Address, Marketing Events.',
        dashboardChartTip: 'Data changes in the past month',
        leadList: 'Lead',
        leadListEx:
            'Leads are the original information obtained when initially contacting customers. This information can be obtained from sources such as business cards at exhibitions, phone numbers from promotional activities, or simple customer information acquired through channels like meetings, advertisements, or external purchases. It can be converted into customers through management and follow-ups.',
        leadPoolEx: `Lead Pool refers to a shared pool of leads within the entire company. The sources of customers are from two parts: 
    1) Members proactively select leads to be placed in the lead pool for other members to claim. 
    2) Lead information of all members is desensitized for contact details such as phone numbers.`,
        leadNameEx: 'When entering the lead name/customer name, please fill in the company name',
        leadPeopleEx: 'Contact name corresponding to the lead/customer',
        PromotionAreaEx: 'the target region for the lead/client',
        dailyConsumptionEx: 'Expenditure on other media in the industry for the lead/customer, in USD',
        promotionBudgetEx: 'Estimated daily advertising budget for the lead/customer, in USD',
        followStatusEx: `-Optional statuses: 
    - Invalid lead: False contact information, false personnel, etc.
    - No response: False contact information, false personnel, etc.
    - Follow-up in progress: Contact has been established, and follow-up is being conducted for the lead/customer.
    - No intention: Indicates that the lead currently has no intention of cooperation
-System statuses:
    - Not assigned: No responsible person has been assigned yet 
    - Pending: Indicates that the lead currently has no intention of cooperation
    - Converted: Indicates that the lead can be converted into a customer. Status after clicking the “Convert to Customer” button 
    - Deactivated: Indicates that the lead is no longer being followed up on. Status after clicking the “Deactivate” button`,
        accountsManager: '客户管理',
        accountsManagerEx:
            'clients are entities or businesses that have directly entered into an business relationship with you by purchasing your products or services to satisfy a certain need. They can be obtained through various channels such as conversion from leads or direct creation.',
        accountsPool: 'Public Sea',
        accountsPoolEx: `Open Sea refers to a shared pool of clients within the entire company. The sources of clients are from two parts: 
    1) Members proactively select clients to be placed in the public pool for other members to claim. 
    2)Clients' information being desnsitized/anonymized for contact information such as phone number.`,
        contactEx:
            'Contacts refer to the  employees with whom you can communicate when interacting with client companies. Regardless of the employee’s role in the company, as long as they can maintain communication and contact, they can be entered as contacts and associated withclientinformation.',
        businessEx:
            'Opportunities, as sales opportunities, emcompass the process of sales personnel discovering prospective clients through dommunication, thereby transfering the intention to closing the deal.. This is known as Business Opportunity Management.​',
        dashBoardEx:
            'Comparison analysis of sales achievements within the selected time period, including customers, contacts, opportunities, opportunity amounts, and follow-up records, demonstrating their growth during the selected time period.The period is compared with the previous adjacent statistical period, such as the comparison of data between adjacent two weeks.',
        salesFunnelEx:
            'Sales funnel data is sourced from the opportunity management module, displaying the sales stages of each opportunity under the filtering conditions in terms of both amount and quantity.',
        dataSummaryEx:
            'Summarize information from the lead, customer, and opportunity modules to provide details on additions, conversions, follow-up status, etc.',
        RankingListEx:
            'The leaderboard displays employee information for the top ten rankings based on different ranking dimensions under the filtering conditions.',
        CustomerFollowEx:
            'Display the number of customers within the filtering conditions who have not had follow-up records added or have not been contacted for a long time within different time intervals.',
        leadLevelEx: `- Super Key Account (KA) Customer: Leading enterprises or well-known brands in the industry, such as those listed in the top 100 of similar product rankings.
- KA Customer: Customers with an overall ad spend of over $50,000 per day.
- Mid-sized Customer: Customers with an overall ad spend of over $5,000 per day.
- Small Micro Customer: Customers with an overall ad spend of less than $5,000 per day.
- Service Provider: Other service providers in the industry, such as payment companies, logistics companies, and advertising agencies, with potential resource cooperation opportunities'`,
        RelatedMarketEx:
            'When the lead/customer source is a marketing event, please fill in the associated marketing event.​​​​',
        TransactionStatusEx: `- Completed: Customers who have completed their first cooperation
- Not completed: Customers with intention but still in progress`,
        contactPeopleEx: 'Designated contact name associated with the customer',
        businessNameEx: 'Designated business opportunity associated with the client',
        businessCountEx: 'Amount to the specified opportunity, in USD',
        ContractingEntityEx: 'Name of the customer entity with which the specified opportunity has been signed',
        ContactDurationTimeEx: 'Contact duration: Current time - creation time',
        leadDurationTimeEx:
            'Lead duration: If converted, duration = conversion time - creation time; if not converted, duration = current time - creation time',
        accountDurationTimeEx:
            'Customer duration: If completed, duration = completion time - creation time; if not completed, duration = current time - creation time',
        opDurationTimeEx:
            'Opportunity duration: Current time at the current stage of the opportunity - stage start time'
    }
};

export default en;
